import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Form, Input, Row, Select, Tooltip } from 'antd'
import { useDispatch } from 'react-redux';
import { CloseOutlined } from "@ant-design/icons";
import { getPPTinformationDetailsReset, getPPTinformationListData, getPPTinformationListReset } from '../../redux/about/actionCreator';
import { useLocation } from 'react-router-dom';

const SearchList = ({ data, setStartRecording, setIsSearchVisble, setIsVisible, isSearchVisble }) => {

    const dispatch = useDispatch();
    const [customValue, setCustomValue] = useState(null)
    const [searchResult, setSearchResult] = useState(false)
    const getPPtInfo = (value) => {
        if (value === undefined || value === null) return;
        // if (setStartRecording) setStartRecording(true);
        console.log(value, "value");
        dispatch(getPPTinformationListData({ id: value }));
        dispatch(getPPTinformationListReset());
        dispatch(getPPTinformationDetailsReset());
        setIsVisible && setIsVisible(false);
        if (setIsSearchVisble) setIsSearchVisble(false)
    };

    const location = useLocation();

    const handleSearch = (value) => {
        const filteredResult = data.filter(item => item.model_name.toLowerCase().includes(value.toLowerCase()))
        if (filteredResult.length === 0) {
            // setSearchResult(true)
            console.log('No matching results found, calling API...', value);
        }
    }

    useEffect(() => {
        if (location?.state?.id && !isSearchVisble) {
            dispatch(getPPTinformationListData({ id: location?.state?.id }));
            dispatch(getPPTinformationListReset());
            dispatch(getPPTinformationDetailsReset());
            setIsVisible && setIsVisible(false);
            if (setIsSearchVisble) setIsSearchVisble(false)
        }
    }, [location?.state?.id]);

    return (
        <Card>
            {searchResult &&
                <div style={{position:'absolute',right:1, top:2,zIndex:50}}>
                    <Tooltip title="Close">
                        <Button
                            type="text"
                            icon={<CloseOutlined />}
                            onClick={() => setSearchResult(false)}
                        />
                    </Tooltip>
                </div>
            }
            <Form layout="vertical">
                {
                    !searchResult ?
                        <Form.Item style={{ marginBottom: 0 }} label="New Product" name="newProduct">
                            <Select
                                style={{ width: "100%" }}
                                placeholder="Please choose the Product"
                                value={""}
                                options={
                                    data &&
                                    data.map((item) => ({ label: item.model_name, value: item.id }))
                                }
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                }
                                filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? "")
                                        .toLowerCase()
                                        .localeCompare((optionB?.label ?? "").toLowerCase())
                                }
                                showSearch
                                notFoundContent={null}
                                allowClear
                                onChange={getPPtInfo}
                                onSearch={handleSearch}
                            />
                        </Form.Item>
                        :
                        <Form.Item style={{ marginBottom: 0 }} label="Other">
                            <Row gutter={8}>
                                <Col span={18}>
                                    <Input
                                        style={{ maxHeight: 32 }}
                                        value={customValue}
                                        onChange={(e) => setCustomValue(e.target.value)}
                                        placeholder="Enter custom product"
                                    />
                                </Col>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        onClick={"handleCustomSubmit"}
                                        style={{ width: '100%' }}
                                    >
                                        Submit
                                    </Button>
                                </Col>
                            </Row>
                        </Form.Item>

                }
            </Form>
        </Card>
    );
};

export default SearchList;
